import { BulkJobProgress } from '@/state/bulkJobs.store';

/**
 * Parses the job.comment string emitted by bulk_action.go:155.
 *
 * Expected format: "Processing: X/Y items (N failed)"
 *
 * Returns null for terminal/empty comments or malformed strings.
 */
export function parseProgress(
  comment: string | null | undefined
): BulkJobProgress | null {
  if (!comment) return null;

  // Match "Processing: 412/547 items (3 failed)"
  const match = comment.match(
    /Processing:\s*(\d+)\/(\d+)\s*items\s*\((\d+)\s*failed\)/i
  );
  if (!match) return null;

  let processed = parseInt(match[1], 10);
  const total = parseInt(match[2], 10);
  let failed = parseInt(match[3], 10);

  if (isNaN(processed) || isNaN(total) || isNaN(failed)) return null;

  // Guard against negative or non-finite total (malformed input).
  if (!isFinite(total) || total < 0) return null;

  // Clamp processed and failed to [0, total].
  processed = Math.max(0, Math.min(processed, total));
  failed = Math.max(0, Math.min(failed, total));

  return { processed, total, failed };
}
